import { endOfDay, startOfDay, subDays } from 'date-fns'

export const DEFAULT_LAST_DAYS = 56
export const MAX_LAST_DAYS = 999

/**
 * A filter period. With `lastDays` set it is a rolling window that ends today,
 * so a stored filter is recomputed from it instead of keeping stale dates.
 */
export interface FilterDateRange {
  from: Date
  to: Date
  lastDays?: number
}

export function isValidLastDays(value: unknown): value is number {
  return (
    typeof value === 'number' &&
    Number.isInteger(value) &&
    value >= 1 &&
    value <= MAX_LAST_DAYS
  )
}

export function getLastDaysRange(
  days: number,
  now = new Date()
): Required<FilterDateRange> {
  return {
    from: startOfDay(subDays(now, days - 1)),
    to: endOfDay(now),
    lastDays: days,
  }
}
